var _module_exports = "<div class=\"no-results__content\">\n  <ng-transclude>\n    No results found.\n  </ng-transclude>\n</div>\n";;
var path = '/workspace/src/app/common/ui/no-results/no-results.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;